<template>
    <div class="form-group">
        <label :for="id || label" v-if="label" :class="labelClass">
            {{ label.charAt(0).toUpperCase() + label.slice(1) }}
        </label>
        <div class="input-wrapper">
            <!-- Slot for left icon or element -->
            <slot name="icon-left" />

            <input
                ref="input"
                :id="id || label"
                :type="type"
                class="form-control"
                :class="[
                    inputClass,
                    { 'error-border': error, 'input-error': error },
                ]"
                :value="modelValue"
                :placeholder="placeholder"
                :required="required"
                :autocomplete="autocomplete"
                v-bind="$attrs"
                @input="$emit('update:modelValue', $event.target.value)"
                @blur="$emit('blurred')"
                @keyup.enter="onEnter && onEnter()"
            />
            <!-- SVG warning icon -->

            <!-- Error Icon -->
            <IconAlertCircle v-if="error" :size="16" class="input-error-icon" />

            <!-- Slot for right icon or content -->
            <slot name="icon-right" />
        </div>

        <span v-if="error" class="error-text">{{ error }} ⚠</span>
    </div>
</template>

<script>
import { IconAlertCircle } from "@tabler/icons-vue";

export default {
    inheritAttrs: false,
    components: { IconAlertCircle },
    props: {
        modelValue: String,
        label: String,
        id: String,
        type: {
            type: String,
            default: "text",
        },
        placeholder: String,
        required: {
            type: Boolean,
            default: false,
        },
        error: String,
        inputClass: {
            type: String,
            default: "",
        },
        autocomplete: {
            type: String,
            default: undefined,
        },
        onEnter: {
            type: Function,
            default: null,
        },
        labelClass: {
            type: String,
            default: "",
        },
    },
};
</script>

<style>
.form-group label {
    display: block;
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 5px;
    color: #555;
    text-align: left;
}
.input-wrapper {
    position: relative;
}
.flat-input {
    width: 100%;
    padding: 12px;
    border: none;
    background: #f9f9ff;
    border-radius: 8px;
    font-size: 14px;
    outline: none;
    text-align: left;
    box-shadow: inset 0 0 0 1px #e0e0e0;
    transition: box-shadow 0.2s ease;
}

flat-input:focus {
    background: #fff;
    box-shadow: 0 0 0 2px #8ee31233;
    outline: none;
}
.flat-input.input-error {
    border: 1px solid #dc3545;
    background-color: #fff6f6;
    padding-right: 42px; /* make room for the icon */
}

.input-error-icon {
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    color: #dc3545;
    font-size: 16px;
    pointer-events: none;
}
.error-text {
    color: var(--danger-dark);
    font-size: var(--font-size-xs);
    margin-top: 0.2rem;
    text-align: left;
    display: block;
}
.flat-input:focus {
    background: #eefbf1;
}
.input-icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    color: #888;
    font-size: 15px;
    pointer-events: none;
}
.flat-input[type="search"] {
    padding-left: 40px; /* leave space for search icon */
}
.input-icon.left {
    position: absolute;
    left: 14px;
    top: 50%;
    transform: translateY(-50%);
    color: #888;
    font-size: 16px;
    pointer-events: none;
}
.input-icon.right {
    position: absolute;
    right: 14px;
    top: 50%;
    transform: translateY(-50%);
    color: #888;
    font-size: 16px;
    pointer-events: none;
}
</style>
